import { RescueEventType } from './../rescue.event.type';
import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, OnDestroy } from '@angular/core';
import { TweenMax, Quint } from 'gsap';
import { CurrentBalanceEventType } from '../../../../shared/current-balance/current-balance.event.type';
import { Rescue } from '../../models/rescue';
import { AppEventDispatcher } from '../../../../utils/AppEventDispatcher';

@Component({
	selector: 'app-rescue-result',
	templateUrl: './rescue-result.component.html',
	styleUrls: ['./rescue-result.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class RescueResultComponent implements OnInit, OnDestroy {

	@Input() rescueData: Rescue;
	@Input() submited = false;
	@Output() setTitleSubtitle: EventEmitter<any> = new EventEmitter<any>();

	private view = '[data-component="rescue-result"]';

	active = false;

	constructor() {
	}

	ngOnInit() {
		AppEventDispatcher.listen(RescueEventType.STEPS.RESCUE_RESULT, data => {

			if (data.show) {
				this.active = true;
				this.show();
			} else {
				this.hide();
			}
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(RescueEventType.STEPS.RESCUE_RESULT);
	}

	show() {
		this.setTitleSubtitle.emit({
			title: 'Resumo de Resgate de Investimento'
		});

		AppEventDispatcher.dispatch(RescueEventType.BUTTONS, { show: false });

		TweenMax.delayedCall(.5, () => {
			const containerHeight = this.getStepHeight();

			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
			TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
		});
	}

	hide() {
		TweenMax.to(this.view, 2.8, { left: '-100%', ease: Quint.easeOut, onComplete: () => {
			this.active = false;
		}});
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/investments/rescue/rescue-result/rescue-result.component.ts